import React from 'react';
import classNames from 'classnames';
import TextField from '@mui/material/TextField';
import Autocomplete from '@mui/material/Autocomplete';
import styles from 'components/admin/deviceDashboard/deviceEditor/DeviceSimulator.module.scss';

const CustomerSelection = (props) => {
  const {
    customers,
    selectedCustomerDisplay,
    onBack,
    onNext,
    onValueChange,
    selectedCustomerId,
  } = props;

  return (
    <>
      <header className={styles.header}>
        <h4>Choose the customer you're running the machine for</h4>
      </header>
      <main className={styles.main}>
        <section className={styles.section}>
          <p>Choose the customer you want to be assigned to as the individual who the turn is run for</p>
          <Autocomplete
            disablePortal
            id="autocomplete-choose-customer"
            getOptionLabel={(option) => {
              return (option.firstName || option.lastName) ? `${option.firstName} ${option.lastName}` : option;
            }}
            options={customers}
            sx={{ width: '300px' }}
            onChange={(event, value) => {
              onValueChange(value);
            }}
            renderInput={(params) => <TextField {...params} label="Customer" />}
            value={selectedCustomerDisplay}
            isOptionEqualToValue={(option, value) => `${option.firstName} ${option.lastName}` === value}
          />
        </section>
      </main>
      <footer className={styles.footer}>
        <p className={styles.backButton} onClick={onBack}>
          Back
        </p>
        <button
          className={classNames(styles.backButton, {
            disabled: !selectedCustomerId,
          })}
          disabled={!selectedCustomerId}
          onClick={onNext}
        >
          Next
        </button>
      </footer>
    </>
  );
};

export default CustomerSelection;
